import { useState } from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { customToastify } from "../../pages/utils/utilsFunctions";
import { Button, Divider } from "@mui/material";
import Typography from "@mui/material/Typography";
import DraggableComponent from "../DraggableComponent";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Slider from "@mui/material/Slider";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

export default function ShadowingSettings(props) {
  const { semiAutoShadowing, handleSemiAutoShadowing } = props;

  return (
    <Box sx={{ width: "310px", display: "block", marginTop: "30px" }}>
      <DraggableComponent maxWidth={"100%"}>
        <Paper style={{ padding: "5px" }}>
          <Divider sx={{ textAlign: "center" }}>تکنیک سایه</Divider>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography>
              تعداد تکرار
              <select
                style={{ width: "50px", height: "27px" }}
                id="repeat"
                value={semiAutoShadowing["repeat"]}
                onChange={(e) => {
                  handleSemiAutoShadowing("repeat", parseInt(e.target.value));
                }}
              >
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
                <option value="19">19</option>
                <option value="20">20</option>
              </select>
            </Typography>

            <Button
              size="small"
              variant="contained"
              onClick={() => {
                handleSemiAutoShadowing("showSettings", false);
              }}
            >
              بستن
            </Button>
          </Box>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={semiAutoShadowing["shortCut"]}
                  onChange={() => {
                    handleSemiAutoShadowing(
                      "shortCut",
                      !semiAutoShadowing["shortCut"]
                    );
                  }}
                />
              }
              label="نمایش کلید فعال سازی"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={semiAutoShadowing["showSubsContents"]}
                  onChange={() => {
                    handleSemiAutoShadowing(
                      "showSubsContents",
                      !semiAutoShadowing["showSubsContents"]
                    );
                  }}
                />
              }
              label="توقف و نمایش زیرنویس"
            />
          </FormGroup>
          <Box
            sx={{ display: "flex", marginBottom: "5px", alignItems: "center" }}
          >
            <Typography sx={{ fontSize: "12px" }}>سطح پیش فرض صدا:</Typography>
            <Slider
              size="small"
              value={semiAutoShadowing[`defaultVolume`]}
              aria-label="Small"
              valueLabelDisplay="on"
              onChange={(e) => {
                handleSemiAutoShadowing(`defaultVolume`, e.target.value);
              }}
            />
          </Box>

          <Divider />
          <Box
            sx={{ display: "flex", width: "310px", flexDirection: "column" }}
          >
            <Box sx={{ display: "flex", width: "300px" }}>
              <Typography
                sx={{
                  width: "75px",
                  fontSize: "12px",
                  textAlign: "center",
                  alignContent: "center",
                }}
              >
                نمایش زیرنویس
              </Typography>
              <Typography
                sx={{
                  width: "75px",
                  fontSize: "12px",
                  textAlign: "center",
                  alignContent: "center",
                }}
              >
                سطح صدا
              </Typography>
              <Typography
                sx={{
                  width: "75px",
                  fontSize: "12px",
                  textAlign: "center",
                  alignContent: "center",
                }}
              >
                سرعت پخش
              </Typography>
              <Typography
                sx={{
                  width: "75px",
                  fontSize: "12px",
                  textAlign: "center",
                  alignContent: "center",
                }}
              >
                تکرار
              </Typography>
            </Box>
            {Array.from(Array(semiAutoShadowing["repeat"] - 1).keys()).map(
              (el) => (
                <Box
                  sx={{
                    display: "flex",
                    width: "300px",
                    marginTop: "5px",
                    border: "1px solid",
                  }}
                  key={el}
                >
                  <Box
                    sx={{
                      width: "75px",
                      fontSize: "12px",
                      textAlign: "center",
                      alignContent: "center",
                      paddingRight: "5px",
                    }}
                  >
                    <select
                      id="hidden"
                      value={
                        semiAutoShadowing[`repeatNumber${el + 1}`]["hidden"]
                      }
                      onChange={(e) => {
                        handleSemiAutoShadowing(
                          `repeatNumber${el + 1}`,
                          e.target.value,
                          "hidden"
                        );
                      }}
                    >
                      <option value="hidden">پنهان</option>
                      <option value="undercover">زیرکاور</option>
                      <option value="show">نمایش</option>
                    </select>
                  </Box>
                  <Box
                    sx={{
                      width: "75px",
                      fontSize: "12px",
                      textAlign: "center",
                      alignContent: "center",
                      paddingRight: "10px",
                    }}
                  >
                    <Slider
                      size="small"
                      value={
                        semiAutoShadowing[`repeatNumber${el + 1}`]["volume"]
                      }
                      aria-label="Small"
                      valueLabelDisplay="auto"
                      onChange={(e) => {
                        handleSemiAutoShadowing(
                          `repeatNumber${el + 1}`,
                          e.target.value,
                          "volume"
                        );
                      }}
                    />
                  </Box>
                  <Box
                    sx={{
                      width: "75px",
                      fontSize: "12px",
                      textAlign: "center",
                      alignContent: "center",
                      paddingRight: "10px",
                    }}
                  >
                    <Slider
                      size="small"
                      value={semiAutoShadowing[`repeatNumber${el + 1}`]["rate"]}
                      aria-label="Small"
                      min={0.5}
                      max={1}
                      step={0.1}
                      valueLabelDisplay="auto"
                      onChange={(e) => {
                        handleSemiAutoShadowing(
                          `repeatNumber${el + 1}`,
                          e.target.value,
                          "rate"
                        );
                      }}
                    />
                  </Box>
                  <Box
                    sx={{
                      width: "75px",
                      fontSize: "12px",
                      textAlign: "center",
                      alignContent: "center",
                      paddingRight: "5px",
                    }}
                  >
                    تکرار {el + 1}
                  </Box>
                </Box>
              )
            )}
            <Box
              sx={{
                display: "flex",
                width: "300px",
                marginTop: "5px",
                border: "1px solid",
              }}
            >
              <Typography
                sx={{
                  width: "75px",
                  fontSize: "12px",
                  textAlign: "center",
                  alignContent: "center",
                }}
              >
                نمایش
              </Typography>
              <Typography
                sx={{
                  width: "75px",
                  fontSize: "12px",
                  textAlign: "center",
                  alignContent: "center",
                }}
              >
                {semiAutoShadowing[`defaultVolume`]}
              </Typography>
              <Typography
                sx={{
                  width: "75px",
                  fontSize: "12px",
                  textAlign: "center",
                  alignContent: "center",
                }}
              >
                1
              </Typography>
              <Typography
                sx={{
                  width: "75px",
                  fontSize: "12px",
                  textAlign: "center",
                  alignContent: "center",
                }}
              >
                تکرار آخر
              </Typography>
            </Box>
          </Box>
        </Paper>
      </DraggableComponent>
    </Box>
  );
}
